'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { MoveableArea } from 'foundations-components/transitional/components/MoveableArea';
import FormFieldFloatingButtonGroup from 'FormsUI/components/editor/form/formFields/FormFieldFloatingButtonGroup';
import LegalConsentFields from 'FormsCommonComponents/LegalConsentFields';
import { CommentableArea } from 'collaboration-sidebar';
import { jsx as _jsx } from "react/jsx-runtime";
export default class LegalConsentPreviewField extends PureComponent {
  render() {
    const {
      option,
      handleSelect,
      handleDelete,
      isSelected
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "GDPR-prompt",
      children: /*#__PURE__*/_jsx(CommentableArea, {
        moduleId: "gdpr-prompt",
        verticalPositioning: true,
        description: {
          translationKey: 'formsGDPRPrompt'
        },
        children: /*#__PURE__*/_jsx(FormFieldFloatingButtonGroup, {
          isLegalConsent: true,
          isDeletable: true,
          isRemovable: true,
          handleEdit: handleSelect,
          handleDelete: handleDelete,
          hasDependentFields: false,
          areDependentFieldsShown: false,
          isSmartField: false,
          isRequired: false,
          isHidden: false,
          handleEditDependentFields: () => {},
          handleShowDependentFields: () => {},
          handleShowQueuedFields: () => {},
          handleToggleRequired: () => {},
          children: /*#__PURE__*/_jsx(MoveableArea, {
            selected: isSelected,
            containerDraggable: true,
            draggable: false,
            onSelectedChange: handleSelect,
            children: /*#__PURE__*/_jsx(LegalConsentFields, {
              legalConsentRecord: option
            })
          })
        })
      })
    });
  }
}
LegalConsentPreviewField.propTypes = {
  handleDelete: PropTypes.func.isRequired,
  handleSelect: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  option: PropTypes.object
};